import withEntity from '@/entity/components/with-entity';

import UserActions from './user-actions';

export default withEntity(UserActions);
